import React from "react";
import { Card } from "@UI/Components/Card/Card";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import useThemeToken from "@UI/hooks/useThemeToken";
import { WhiteSuperTalentBadge } from "@UI/Components/Icons/WhiteSuperTalent";
import { Icon } from "@UI/Components/Icon/Icon";
import messages from "./messages";
import { TrackingCard } from "../SuperTalent/TrackingCard";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { Heading } from "@UI/Components/Heading/Heading";

export const SuperTalentGoalCard = ({ context }) => {
  const navigate = useNavigate();

  const pink500 = useThemeToken("colors", "pink.500");
  const orange500 = useThemeToken("colors", "orange.500");
  const pink600 = useThemeToken("colors", "pink.600");
  const orange600 = useThemeToken("colors", "orange.600");

  const handleOnClick = () => {
    navigate(["SUPERTALENT_OBJECTIVES"]);
  };

  return (
    <Card
      shadow={null}
      paddingX={["4", "4", "4"]}
      paddingY={["4", "4", "4"]}
      background={`linear-gradient(96.51deg, ${pink500} 0%, ${orange500} 99.87%);`}
      _hover={{
        background: `linear-gradient(96.51deg, ${pink600} 0%, ${orange600} 99.87%);`,
      }}
      w="full"
      h="fit-content"
      cursor="pointer"
      mt={{ base: 5, md: 8 }}
    >
      <Heading
        as="h4"
        textAlign="left"
        color="white"
        mb={3}
        fontWeight={700}
        fontSize={{ base: "24px", lg: "28px" }}
      >
        <FormattedMessage
          {...messages.superTalentGoal}
          values={{
            superTalentBadge: () => (
              <Icon
                as={WhiteSuperTalentBadge}
                boxSize={{ base: 4, lg: 6 }}
                marginRight="2px"
                marginBottom="5px"
                display="inline"
              />
            ),
          }}
        />
      </Heading>
      <TrackingCard type={context} onClick={handleOnClick} />
    </Card>
  );
};
